import { Injectable } from '@angular/core';
import { ErrorMessageResponse } from '@app/core/models/data-response';
import { DataTaskService } from '@app/core/services/data-task.service';

@Injectable({
    providedIn: 'root',
})
export class DocPackTypeService {
    constructor(private datatask: DataTaskService) {}

    /**
     * Retrieves the doc pack type with the given params.
     *
     * @datatask 3285
     * @datataskName sp_ws_p2_w_docpacktype_get
     * @param params the keyno for the dockpack type to get.
     * @returns promise containing the docpack type.
     */
    public async getDocPackType(params: GetDocPackTypeParams): Promise<DocPackTypeGet> {
        return (await this.datatask.Post(3285, params))[0];
    }

    /**
     * Saves the given doc pack type.
     *
     * @datatask 3286
     * @datataskName sp_ws_p2_w_docpacktype_save
     * @param params the doc pack to save wiht changed values.
     * @returns promise containing error message response.
     */
    public async saveDocPackType(params: DocPackTypeGet): Promise<DocPackTypeSaveResponse> {
        return (await this.datatask.Post(3286, params))[0];
    }

    /**
     * Deletes the given doc pack type.
     *
     * @datatask 3287
     * @datataskName sp_ws_p2_w_docpacktype_delete
     * @param params the doc pack to delete.
     * @returns promise containing error message response.
     */
    public async deleteDocPackType(params: DocPackTypeGet): Promise<ErrorMessageResponse> {
        return (await this.datatask.Post(3287, params))[0];
    }

    public async getDocPackFormatStyle(params: GetDocPackTypeFormatStyleParams): Promise<DocPackTypeFormatStyleGet> {
        return (await this.datatask.Post(3959, params))[0];
    }

    public async saveDocPackFormatStyle(params: DocPackTypeFormatStyleGet): Promise<ErrorMessageResponse> {
        return (await this.datatask.Post(3961, params))[0];
    }

    public async getDocPackgetElements(params: GetDocPackTypeFormatStyleElementsParams): Promise<DocPackTypeFormatStyleElementItem[]> {
        return await this.datatask.Post(3960, params);
    }

    public async saveDocPackFormatStyleElements(params: DocPackTypeFormatStyleElementItem[]): Promise<ErrorMessageResponse> {
        return (await this.datatask.Post(3962, { items: params }))[0];
    }
}

export interface GetDocPackTypeParams {
    docpacktype_keyno: string;
}

export interface DocPackTypeGet {
    docpacktype_keyno: string;
    docpacktype_name: string;
    html_text_frontpage: string;
    html_text_indexpage: string;
    reg_datetime: string;
    reg_by_portal_user_name: string;
}

export interface DocPackTypeSaveResponse extends ErrorMessageResponse {
    docpacktype_keyno: string;
}

export interface DocPackTypeFormatStyleGet {
    docpacktype_get_keyno: string;
    docpacktype_keyno: string;
    margin_top: number;
    margin_right: number;
    margin_bottom: number;
    margin_left: number;
    show_pagenumber: boolean;
    show_pagenumber_firstpage: boolean;
    pagenumber_color: string;
    pagenumber_fontsize: number;
    pagenumber_x: number;
    pagenumber_y: number;
    additional_styling: string;
    background_template: string;
    background_template_filename: string;
    generated_style: string;
}

export interface GetDocPackTypeFormatStyleParams {
    docpacktype_keyno: string;
}

export interface DocPackTypeFormatStyleElementItem {
    docpacktype_get_element_keyno: string;
    docpacktype_get_keyno: string;
    element: string;
    elementtag: string;
    icon: string;
    fontsize: string | number;
    textalign: string;
    fontfamily: string;
    fontstyle: string;
    textcolor: string;
    backgroundcolor: string;
}

export interface GetDocPackTypeFormatStyleElementsParams {
    docpacktype_get_keyno: string;
}
